export const getVersionText = (version) => {
  if (Math.abs(version.major - 0x7FFFFFFF) < 0.1)
    return "Current version";
  return '' + version.major + '.' + version.minor + '.' + version.build;
}

export const getVersionDestructor = (version) => {
  return { ...version, text: getVersionText(version) };
}

export const getVersionDestructorArr = (versions) => {
  let result = [];
  for (let version of versions)
    result.push(getVersionDestructor(version));
  return result;
}



// WEBPACK FOOTER //
// ./src/components/Utils.js